import { DefaultQueryParams } from '@frontend/api-utils';
import { ChartClient } from '@frontend/chart/api';
import { PudoTransactionTimerActivityWeekdayHeatmapChart } from '@frontend/chart/components';
import { Chart } from '@frontend/chart/types';
import { useEffect, useState } from 'react';

import { getLast6MonthsChartRange } from '../../../statistics/pudo/last-30-days-chart-range';
import { weekdayHeatmapWindow } from '../insight-detail/insight-heatmap-window';
import { useInsightFetchRange } from '../insight-detail/use-insight-fetch-range';

export const useLast6MonthsPudoTransactionTimerActivityWeekdayHeatmapChart = (accountId: string) => {
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [rangeStart, setRangeStart] = useState<string | undefined>(undefined);
    const [weekCount, setWeekCount] = useState<number | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    const fetchRange = useInsightFetchRange(getLast6MonthsChartRange);

    useEffect(() => {
        if (!accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        const { after, before } = fetchRange;
        const heatmapWindow = weekdayHeatmapWindow(after, before);
        setRangeStart(heatmapWindow.rangeStart);
        setWeekCount(heatmapWindow.weekCount);

        ChartClient.fetchChartData(accountId, PudoTransactionTimerActivityWeekdayHeatmapChart.definition, {
            [DefaultQueryParams.AFTER]: after,
            [DefaultQueryParams.BEFORE]: before,
            ...fetchRange.entityParams
        })
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [accountId, fetchRange.key]);

    return {
        data,
        isLoading,
        rangeStart,
        weekCount
    };
};
